<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} </strong></h2>

<ngx-spinner [zIndex]="100" name="spExpedienteVinculado" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">

  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>
      <app-buscar-expediente (eventEntity)="selectExpediente($event)"></app-buscar-expediente>
    </ng-template>
  </form>


</mat-dialog-content>

<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid"
    (click)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Modificar"></app-button-save>

  <app-button-delete (click)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete>
</mat-dialog-actions>
